import React, { Fragment, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "../../assets/css/scss/section/_channel.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faChevronCircleRight,
//   faChevronCircleLeft,
// } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import "../../assets/css/scss/section/player/_playerImageSlider.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Channel() {
  // eslint-disable-next-line
  const [activeSilderIndex, setactiveSilderIndex] = useState(0);
  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <FontAwesomeIcon icon={"chevron-circle-right"} />,
    prevArrow: <FontAwesomeIcon icon={"chevron-circle-left"} />,
    // arrows: false,
    autoplay: true,
    afterChange: (current: number) => setactiveSilderIndex(current),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          autoplay: false,
        },
      },
    ],
  };
  return (
    <Fragment>
      <section className="channel-section">
        <Container>
          <Row className="justify-content-end">
            <Col lg={10} xl={9}>
              <div className="title theme-dark-gray">
                <h2 className="bold h5 theme-green mb-0">
                  All Sports Channels
                </h2>
              </div>
              {/* d-flex align-items-center justify-content-around */}
              <div className="brand-logo theme-light-gray slider-wrapper align-items-center justify-content-around">
                <Slider {...settings}>
                  <div className="anchor">
                    <Image src="/assets/images/fox.png" alt="fox" fluid />
                  </div>
                  <div className="anchor">
                    <Image src="/assets/images/bein.png" alt="bein" fluid />
                  </div>
                  <div className="anchor">
                    <Image src="/assets/images/sky.png" alt="sky" fluid />
                  </div>
                  <div className="anchor">
                    <Image
                      src="/assets/images/tensports.png"
                      alt="Ten Sport"
                      fluid
                    />
                  </div>
                  <div className="anchor">
                    <Image src="/assets/images/espn.png" alt="espn" fluid />
                  </div>
                  {/* <div className="anchor">
                    <Image src="/assets/images/espn.png" alt="espn" fluid />
                  </div>
                  <div className="anchor">
                    <Image src="/assets/images/espn.png" alt="espn" fluid />
                  </div>
                  <div className="anchor">
                    <Image src="/assets/images/espn.png" alt="espn" fluid />
                  </div> */}
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
}
